module.exports = __webpack_public_path__ + "img/activate-admin-download-app.aa104059.png";